// components/subscription/CreditManagement/styles.js
import styled from 'styled-components';
import { motion } from 'framer-motion';

export const ModalOverlay = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${props => props.theme.zIndex.modal};
    padding: ${props => props.theme.spacing.xl};
`;

export const ModalContent = styled(motion.div)`
    background: white;
    border-radius: ${props => props.theme.borderRadius.lg};
    width: 100%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;

    .content {
        padding: ${props => props.theme.spacing.xl};
    }

    .current-credits {
        margin-bottom: ${props => props.theme.spacing.xl};

        h3 {
            font-size: ${props => props.theme.typography.sizes.xl};
            margin-bottom: ${props => props.theme.spacing.sm};
        }

        p {
            color: ${props => props.theme.colors.text.secondary};
            
            &.limit-info {
                font-size: ${props => props.theme.typography.sizes.sm};
                margin-top: ${props => props.theme.spacing.xs};
                color: ${props => props.theme.colors.text.disabled};
            }
        }
    }

    .actions {
        display: flex;
        gap: ${props => props.theme.spacing.md};
        margin-top: ${props => props.theme.spacing.xl};

        button {
            flex: 1;
        }
    }
`;

export const ModalHeader = styled.div`
    padding: ${props => props.theme.spacing.xl};
    border-bottom: 1px solid ${props => props.theme.colors.border};
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2 {
        font-size: ${props => props.theme.typography.sizes["2xl"]};
        margin: 0;
    }
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    color: ${props => props.theme.colors.text.secondary};
    cursor: pointer;
    padding: ${props => props.theme.spacing.xs};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${props => props.theme.borderRadius.full};
    transition: all ${props => props.theme.transitions.fast};

    &:hover {
        background: ${props => props.theme.colors.background.alt};
        color: ${props => props.theme.colors.text.primary};
    }
`;

export const CreditOptions = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: ${props => props.theme.spacing.md};
    margin-bottom: ${props => props.theme.spacing.xl};
`;

export const CreditOption = styled.div`
    background: ${props => props.selected ? props.theme.colors.primary.light : 'white'};
    border: 2px solid ${props => props.selected ? props.theme.colors.primary.main : props.theme.colors.border};
    border-radius: ${props => props.theme.borderRadius.lg};
    padding: ${props => props.theme.spacing.lg};
    cursor: pointer;
    text-align: center;
    transition: all ${props => props.theme.transitions.normal};

    &:hover {
        border-color: ${props => props.theme.colors.primary.main};
        transform: translateY(-2px);
    }

    h4 {
        font-size: ${props => props.theme.typography.sizes.lg};
        margin-bottom: ${props => props.theme.spacing.sm};
        color: ${props => props.selected ? props.theme.colors.primary.dark : props.theme.colors.text.primary};
    }

    .hours {
        font-size: ${props => props.theme.typography.sizes.xl};
        font-weight: ${props => props.theme.typography.weights.bold};
        color: ${props => props.selected ? props.theme.colors.primary.dark : props.theme.colors.text.primary};
        margin-bottom: ${props => props.theme.spacing.sm};
    }
`;

export const PriceTag = styled.div`
    display: inline-block;
    background: ${props => props.theme.colors.background.alt};
    padding: ${props => `${props.theme.spacing.xs} ${props.theme.spacing.sm}`};
    border-radius: ${props => props.theme.borderRadius.md};
    font-size: ${props => props.theme.typography.sizes.sm};
    color: ${props => props.theme.colors.text.secondary};
`;

export const Summary = styled.div`
    background: ${props => props.theme.colors.background.alt};
    border-radius: ${props => props.theme.borderRadius.lg};
    padding: ${props => props.theme.spacing.lg};
    margin-bottom: ${props => props.theme.spacing.xl};

    .summary-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: ${props => props.theme.spacing.sm};
        
        &:last-child {
            margin-bottom: 0;
        }

        &.total {
            margin-top: ${props => props.theme.spacing.md};
            padding-top: ${props => props.theme.spacing.md};
            border-top: 1px solid ${props => props.theme.colors.border};
            font-weight: ${props => props.theme.typography.weights.bold};
            font-size: ${props => props.theme.typography.sizes.lg};
        }

        span:first-child {
            color: ${props => props.theme.colors.text.secondary};
        }
    }
`;